import React, { Component } from 'react';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import GusetNavbar from '../navigation/guestnavbar.jsx'
import Recaptcha from 'react-recaptcha'
import creditcardlogo from '../../images/credit-cards-vector-icon-.jpg'
import {
    withRouter
} from 'react-router-dom';
import {
    Step,
    Stepper,
    StepLabel,
} from 'material-ui/Stepper';
import ArrowForwardIcon from 'material-ui/svg-icons/navigation/arrow-forward';
import answerimg from '../../images/answer.png'
import * as actions from '../../actions/actions.jsx'
import s from '../../services/allservices.jsx'
import { connect } from 'react-redux';
import service from '../../services//allservices.jsx'
import { ToastContainer, toast } from 'react-toastify';
// import Input from '@material-ui/core/Input';
import LoaderSmall from "../loader/loadersmall.jsx"
// import Input from 'material-ui/core/Input';
// import InputLabel from 'material-ui/core/InputLabel';
// import FormHelperText from 'material-ui/core/FormHelperText';
// import FormControl from 'material-ui/core/FormControl';

const mapStateToProps = state =>
    ({
        publicKey: state.publicKey.publicKey,
        passwordState: state.getPasswordReducer.passwordState

    })
const mapDispatchToProps = dispatch =>
    ({
        fetchPassword(userid) {
            dispatch(
                actions.getPasswordAction(userid)
            )
        }
    })

const styles = {
    button: {
        margin: 12,
        background: "#2a5194"
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
    customWidth: {
        width: 150,
    },
    focusStyle: {
        borderTop: "none #333",
        borderLeft: "none #333",
        borderRight: "none #333",
        borderBottom: "2px solid #333"
    },
    focusTextStyle: {
        color: "#333"
    }
};
var callback = function () {

};

// specifying verify callback function
var verifyCallback = function (response) {

};
let recaptchaInstance;
const resetRecaptcha=()=>{
    recaptchaInstance.reset()
}
const JSEncrypt = window.JSEncrypt
class ForgotPassword extends Component {
    constructor(props) {
        super(props);
        this.state = {
            stepIndex: 0,
            response: "",
            userId: '',
            secretPassword: '',
            secretQuestionCode: '',
            accountId: '',
            answer:'',
            correctpass:true,
            applicationId: '',
            disabled: true,
            disabledpass:true,
        }
    }
    handleGoback(e) {
        localStorage.clear();
        this.props.history.push("/logout")
    }
    componentDidMount() {

    }

    handleText(e) {
        const userid = e.target.value
        this.setState({
            userId: userid
        }, () => {
            if (this.state.userId.length !== 0) {
                this.setState({
                    disabled: false
                })
            }
            else {
                this.setState({
                    disabled: true
                })
            }

        })



    }
    handelReset =()=>{

    }
    verifyCallback = response => {
      
        this.setState({
            response: response

        })
    }

    handleAnswer(e,value) {
        const answer = e.target.value
        this.setState({
            secretPassword: answer
        }, () => {
            if (this.state.secretPassword.length !== 0) {
                this.setState({
                    disabledpass: false
                })
            }
            else {
                this.setState({
                    disabledpass: true
                })
            }
        })
    }

    getPassword(accountid, secretQuestionCode) {
        const { response ,correctpass} = this.state
        const { publicKey } = this.props
        if(correctpass=== false){
            this.setState({
                correctpass: false,
            })
        }

        let _this = this
        if (response !== '') {
            if (publicKey.status === 200) {
                const public_Key = publicKey.body.publickey;
                let encrypt = new JSEncrypt();
                encrypt.setPublicKey(public_Key);

                const state = {
                    accountId: encrypt.encrypt(accountid),
                    applicationId: "gmcabs",
                    secretPassword: encrypt.encrypt(this.state.secretPassword),
                    secretQuestionCode: encrypt.encrypt(secretQuestionCode)
                }
                this.setState({
                    loader: true
                })

                fetch(service.forgot_password + "/?g-recaptcha-response=" + response, {
                    credentials: "same-origin",
                    method: 'POST',
                    headers: new Headers({
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(state)
                })
                    .then(response => {
                        if (response.status === 200 || response.status === 201 || response.status === 204) {

                            toast.success(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                            this.setState({
                                loader: false,

                            })
                            setTimeout(function () {
                                _this.props.history.push('/');
                            }, 3000);

                        }
                        else {
                            // let errResponseText= response.headers.get('message')
                            // console.log(errResponseText)
                            toast.error(response.headers.get('message'), {
                                position: "top-right",
                                draggablePercent: 60,
                                autoClose: 3000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: false
                            });
                           

                            resetRecaptcha()
                            document.getElementById("secretAns").value=""
                            document.getElementById("secretAns").focus()
                            this.setState({
                                loader: false,
                            })
                        }
                    })
            }

        }
    }
    handleContinue(e) {
        this.props.history.push('/setuserid')
    }
    checkObject(obj) {
        for (var prop in obj) {
            if (obj.hasOwnProperty(prop)) {
                return true;
            } else {
                return false
            }

        }
    }
    getStepContent(stepIndex) {
        const { passwordState } = this.props
        const {correctpass} = this.state
        switch (stepIndex) {
            case 0:
                return (
                    <div>
                        <div className="container">
                            <div className="row">
                                <ToastContainer
                                    draggablePercent={60}
                                    position="top-right"
                                    autoClose={3000}
                                    hideProgressBar={false}
                                    newestOnTop
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable={false}
                                    pauseOnHover
                                />
                                <div className="col-sm-12">
                                    <div className="col-sm-12">
                                        <div className="col-md-12" >
                                            <div className="row box-shadow-style" style={{ padding: "12px 15px", minHeight: "100px" }} >
                                                <div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <h4>Forgot Your Password?</h4>
                                                        </div>

                                                        <div className="col-md-12" style={{ fontSize: "13px" }}>
                                                            <span>Here you can retrieve your password.</span>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ padding: "0px 15px", marginTop: "20px" }}>
                                            <div className="row box-shadow-style" style={{ padding: "12px 15px", minHeight: "300px" }} >
                                                <div className="summary-header">
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <p>Please Enter Your User ID</p>
                                                        </div>
                                                        <div className="col-md-12">

                                                            <div className="row" >
                                                                <div className="row input-group" >
                                                                    <div className="offset-md-1 col-sm-2 input-icon" >
                                                                        <i className="fa fa-user text-dark " aria-hidden="true"></i>
                                                                    </div>
                                                                    <div className="col-sm-9" >
                                                                        <TextField
                                                                            hintText="User ID"
                                                                            floatingLabelText="User ID"
                                                                            type="text"
                                                                            name="userid"
                                                                            maxLength="50"
                                                                            className="my-className"
                                                                            underlineFocusStyle={styles.focusStyle}
                                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                                            onChange={this.handleText.bind(this)}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row input-group"  >

                                                                    <div className="offset-md-2 col-sm-4 nopadding" style={{ marginTop: '20px' }}  >
                                                                        <RaisedButton
                                                                            label="Go Back To HomePage"
                                                                            // style={styles.button}
                                                                            backgroundColor="#333"
                                                                            labelColor="#fff"
                                                                            onClick={this.handleGoback.bind(this)}
                                                                            icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                        />
                                                                    </div>
                                                                    <div className="col-sm-3" style={{ marginTop: '20px' }} >
                                                                        <RaisedButton
                                                                            label="Continue"
                                                                            // style={styles.button}
                                                                            backgroundColor="#333"
                                                                            disabled={this.state.disabled}
                                                                            id="continuebtn"
                                                                            labelColor="#fff"
                                                                            onClick={this.handleNext.bind(this)}
                                                                            icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                        />
                                                                    </div>
                                                                    
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                );
            case 1:
                return (

                    <div>
                        {this.checkObject(passwordState) ?
                            <div className="row">
                                <ToastContainer
                                    draggablePercent={60}
                                    position="top-right"
                                    autoClose={3000}
                                    hideProgressBar={false}
                                    newestOnTop
                                    closeOnClick
                                    rtl={false}
                                    pauseOnVisibilityChange
                                    draggable={false}
                                    pauseOnHover
                                />
                                <div className="col-sm-12">

                                    <div className="col-sm-12">
                                        <div className="col-md-12">
                                            <div className="row box-shadow-style" style={{ padding: "12px 15px", minHeight: "100px" }} >
                                                <div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <p>Forgot Your Password?</p>
                                                        </div>

                                                        <div className="col-md-12" style={{ fontSize: "13px" }}>
                                                            <span>Here you can retrieve your password.</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-12" style={{ padding: "0px 15px", marginTop: "20px" }}>
                                            <div className="row box-shadow-style" style={{ padding: "12px 15px", minHeight: "100px" }} >
                                                <div>
                                                    <div className="row">
                                                        <div className="col-md-12">
                                                            <p>Please answer the following question for verification.</p>
                                                        </div>
                                                        <div className="col-md-12">
                                                            <div className="row">
                                                                <div className="offset-md-1 col-md-10">
                                                                    <label className="col-md-4 ">Secret Question : </label>
                                                                    <span className="col-md-6 nopadding" style={{marginLeft:"-20px"}}>{passwordState.body.secretQuestionDescription + "?"}
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-12">
                                                            <div className="row" >
                                                                <div className="row input-group" >
                                                                    <div className="offset-md-1 col-2 input-icon" >
                                                                        <img src={answerimg} alt="" />
                                                                    </div>
                                                                    <div className="col-sm-9" >
                                                                        <TextField
                                                                            hintText=" Answer"
                                                                            floatingLabelText="Secret Answer"
                                                                            type="text"
                                                                            name="answer"
                                                                            id="secretAns"
                                                                            maxLength="50"
                                                                            className="my-className"
                                                                            underlineFocusStyle={styles.focusStyle}
                                                                            floatingLabelFocusStyle={styles.focusTextStyle}
                                                                            onChange={this.handleAnswer.bind(this)}
                                                                            errorText={correctpass ? null : "Please enter secert answer"}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="offset-md-5 col-sm-7 text-center margin-capcha">
                                                                        <Recaptcha
                                                                            sitekey="6LeRorofAAAAACriDJ7aN2WI9LOCRz8aN2KzqU3C"
                                                                            render="explicit"
                                                                            verifyCallback={this.verifyCallback}
                                                                            onloadCallback={callback}
                                                                            ref={e => recaptchaInstance=e}
                                                                        />
                                                                    </div>
                                                                </div>
                                                                <div className="row input-group" style={{ marginTop: "15px" }} >
                                                                    <div className="col-sm-12 " style={{ marginLeft: "145px" }}>
                                                                        <label style={{ fontSize: "15px", color: "rgb(66, 62, 62)" }}>
                                                                        Password to be emailed to : {passwordState.body.emailId}
                                                                        </label>
                                                                    </div>

                                                                </div>
                                                                <div className="row input-group"  >

                                                                    <div className="offset-md-2 col-sm-4 nopadding " style={{ marginTop: '20px' }} >
                                                                        <RaisedButton
                                                                            label="Go Back To HomePage"
                                                                            // style={styles.button}
                                                                            backgroundColor="#333"
                                                                            labelColor="#fff"
                                                                            onClick={this.handleGoback.bind(this)}
                                                                            icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                        />
                                                                    </div>
                                                                    <div className="col-sm-3 nopadding" style={{ marginTop: '20px' }} >
                                                                        <RaisedButton
                                                                            label="Get Password"
                                                                            // style={styles.button}
                                                                            backgroundColor="#333"
                                                                            labelColor="#fff"
                                                                           
                                                                            disabled={this.state.disabledpass}
                                                                            onClick={this.handleContinue.bind(this)}
                                                                            icon={<i className="fa fa-sign-in" aria-hidden="true" style={{ color: "#fff" }}></i>}
                                                                            onClick={(e) => { this.getPassword(passwordState.body.accountId, passwordState.body.secretQuestionCode) }}
                                                                        />
                                                                    </div>
                                                                    {this.state.loader === true &&
                                        <div className="col-sm-1" style={{ marginTop: "-17px", width: "30% !mportant" }} >
                                            <LoaderSmall />
                                        </div>}
                                                                </div>

                                                            </div>
                                                            </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div> :
                            <div>
                            </div>}
                    </div>
                );
            default:
                return (
                    <div>Something Went Wrong</div>
                )
        }
    }
    sendUserDetail(userDetail) {
        this.setState({ stepIndex: 1, userDetailState: userDetail });
    }
    handleStepCount7() {
        const { passwordState } = this.props
        const { stepIndex } = this.state;
        // console.log(passwordState)
        if (passwordState.status === 200) {
     
                this.setState({ stepIndex: stepIndex + 1 });
            

        }
        else {
            this.setState({ stepIndex: stepIndex }, () => {
                toast.error(passwordState, {
                    position: "top-right",
                    draggablePercent: 60,
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: false
                });
            })
        }
    }
    handleNext() {

        let _this = this
        // const { publicKey } = this.props
        // if (publicKey.status === 200) {
        //     const public_Key = publicKey.body.publickey;
        //     let encrypt = new JSEncrypt();
        //     encrypt.setPublicKey(public_Key);

        this.props.fetchPassword(this.state.userId)
        //}


        setTimeout(function () {
            _this.handleStepCount7()
        }, 1500)




    }
    handlePrev() {
        const { stepIndex } = this.state;

        if (stepIndex > 0) {
            this.setState({ stepIndex: stepIndex - 1 });
        }
    }
    handleStep1() {
        this.setState({ stepIndex: 2 });
    }

    render() {
        const { stepIndex } = this.state;
        return (
            <div>
                <ToastContainer
                    draggablePercent={60}
                    position="top-right"
                    autoClose={3000}
                    hideProgressBar={false}
                    newestOnTop
                    closeOnClick
                    rtl={false}
                    pauseOnVisibilityChange
                    draggable={false}
                    pauseOnHover
                />
                <div><GusetNavbar /> </div>
                <div style={{ width: '100%', maxWidth: 700, margin: 'auto', marginTop: "80px" }}>
                    <Stepper activeStep={stepIndex} connector={<ArrowForwardIcon />}>
                        <Step className="step">
                            <StepLabel>Forgot User Id</StepLabel>
                        </Step>

                        <Step className="step">
                            <StepLabel>Verify & Submit</StepLabel>
                        </Step>
                    </Stepper>

                    {this.getStepContent(stepIndex)}


                </div>
            </div>
        );
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ForgotPassword))


// WEBPACK FOOTER //
// ./src/components/forgotpassword/forgotPassword.jsx